import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import App from './App.vue'
import store from '@/vuex/store'
// import VueSocketIO from 'vue-socket.io'
import Settings from '@/config/Settings'
import { mappingRoutes } from '@/Route.js'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import VueClipboard from 'vue-clipboard2'
import '@/core/js/Copyright'

// import 'aframe'
// import 'aframe-chromakey-material'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCheck)

// import { TweenMax, CSSPlugin, TimelineMax, Expo, Back, ScrollToPlugin, DirectionalRotationPlugin, BezierPlugin } from 'gsap/all'
// const gsapPlugins = [ TweenMax, CSSPlugin, TimelineMax, Expo, Back, ScrollToPlugin, DirectionalRotationPlugin, BezierPlugin ]

// import '@/commons/js/gsap/ThrowPropsPlugin'
// import '@/commons/js/gsap/CustomEase'
// // import 'gsap-babylon-plugin'

import isMobile from 'ismobilejs'
import ToggleButton from 'vue-js-toggle-button'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(ToggleButton)
Vue.use(VueRouter)
Vue.use(Meta,{ keyName: 'head' })
Vue.mixin(Translation)
Vue.use(VueClipboard)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

// require('aframe-effects')

const routes = [ 
    { id: 'other', name: 'other', component: 'Other_AR', fr: '/', en: '/bottle/' },
    { id: 'testing', name: 'testing', component: 'Bottle', fr: '/test/', en: '/testing/' },
]

const router = new VueRouter({
    mode: 'history',
    routes: mappingRoutes(routes)
})

new Vue({
    router,
    store,
    mixins: [ LangMixin ],
    head() {
        return {
            htmlAttrs: { lang: this.lang }
        }
    },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
        isDev: process.env.NODE_ENV !== 'production',
        isProd: process.env.NODE_ENV === 'production',
    }),
    beforeCreate() {

        this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
        this.$store.commit('app/SET_FROM_ROUTE', this.$route)
        this.$store.commit('app/SET_TO_ROUTE', this.$route)
    },
    created() {
        window.addEventListener('resize', this.onResize)
        this.is_apple = isMobile(window.navigator).apple.device
        this.$sizes =  {
            phone: 767,
            tabletPortrait: 768,
            tablet: 1024,
        }
    },
    mounted() {
        this.onResize()
        if(window.navigator.language.indexOf("en") != -1)
            this.langSwitch('en')
        else 
            this.langSwitch('fr')
    },
    methods: {
        onResize() {
            this.width = window.innerWidth
            this.height = window.innerHeight
        },
        below(type) { return this.width <= this.$sizes[type] },
        above(type) { return this.width >= this.$sizes[type] }
    },
    render: h => h(App)
}).$mount('#app')


